import { extractTopLevelDomain } from './tld';
var VISTA_COM_HOST = 'vista.com';
export var getCurrentCountry = function (host, path) {
    var tld;
    // Backwards compatibility for testing
    if (host === 'localhost') {
        tld = 'IE';
    }
    else if (host === VISTA_COM_HOST) {
        tld = path === '/' ? 'us' : path.substr(1, 2);
    }
    else {
        tld = extractTopLevelDomain(host);
    }
    switch (tld.toLowerCase()) {
        case 'pt':
            return 'PT';
        case 'ie':
            return 'IE';
        case 'es':
            return 'ES';
        case 'in':
            return 'IN';
        case 'jp':
            return 'JP';
        case 'com':
        case 'us':
            return 'US';
        case 'fr':
            return 'FR';
        case 'it':
            return 'IT';
        case 'uk':
            return 'GB';
        case 'de':
            return 'DE';
        case 'nl':
            return 'NL';
        case 'dk':
            return 'DK';
        case 'se':
            return 'SE';
        case 'at':
            return 'AT';
        case 'no':
            return 'NO';
        case 'fi':
            return 'FI';
        case 'be':
            return 'BE';
        case 'sg':
            return 'SG';
        case 'nz':
            return 'NZ';
        case 'au':
            return 'AU';
        case 'ca':
            return 'CA';
        case 'ch':
            return 'CH';
    }
    throw new Error("Unknown country for host " + host + " and path " + path);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291bnRyeS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvY291bnRyeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUscUJBQXFCLEVBQUUsTUFBTSxPQUFPLENBQUM7QUFFOUMsSUFBTSxjQUFjLEdBQUcsV0FBVyxDQUFDO0FBRW5DLE1BQU0sQ0FBQyxJQUFNLGlCQUFpQixHQUFHLFVBQUMsSUFBWSxFQUFFLElBQVk7SUFDMUQsSUFBSSxHQUFHLENBQUM7SUFFUixzQ0FBc0M7SUFDdEMsSUFBSSxJQUFJLEtBQUssV0FBVyxFQUFFO1FBQ3hCLEdBQUcsR0FBRyxJQUFJLENBQUM7S0FDWjtTQUFNLElBQUksSUFBSSxLQUFLLGNBQWMsRUFBRTtRQUNsQyxHQUFHLEdBQUcsSUFBSSxLQUFLLEdBQUcsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQztLQUMvQztTQUFNO1FBQ0wsR0FBRyxHQUFHLHFCQUFxQixDQUFDLElBQUksQ0FBQyxDQUFDO0tBQ25DO0lBRUQsUUFBUSxHQUFHLENBQUMsV0FBVyxFQUFFLEVBQUU7UUFDekIsS0FBSyxJQUFJO1lBQ1AsT0FBTyxJQUFJLENBQUM7UUFDZCxLQUFLLElBQUk7WUFDUCxPQUFPLElBQUksQ0FBQztRQUNkLEtBQUssSUFBSTtZQUNQLE9BQU8sSUFBSSxDQUFDO1FBQ2QsS0FBSyxJQUFJO1lBQ1AsT0FBTyxJQUFJLENBQUM7UUFDZCxLQUFLLElBQUk7WUFDUCxPQUFPLElBQUksQ0FBQztRQUNkLEtBQUssS0FBSyxDQUFDO1FBQ1gsS0FBSyxJQUFJO1lBQ1AsT0FBTyxJQUFJLENBQUM7UUFDZCxLQUFLLElBQUk7WUFDUCxPQUFPLElBQUksQ0FBQztRQUNkLEtBQUssSUFBSTtZQUNQLE9BQU8sSUFBSSxDQUFDO1FBQ2QsS0FBSyxJQUFJO1lBQ1AsT0FBTyxJQUFJLENBQUM7UUFDZCxLQUFLLElBQUk7WUFDUCxPQUFPLElBQUksQ0FBQztRQUNkLEtBQUssSUFBSTtZQUNQLE9BQU8sSUFBSSxDQUFDO1FBQ2QsS0FBSyxJQUFJO1lBQ1AsT0FBTyxJQUFJLENBQUM7UUFDZCxLQUFLLElBQUk7WUFDUCxPQUFPLElBQUksQ0FBQztRQUNkLEtBQUssSUFBSTtZQUNQLE9BQU8sSUFBSSxDQUFDO1FBQ2QsS0FBSyxJQUFJO1lBQ1AsT0FBTyxJQUFJLENBQUM7UUFDZCxLQUFLLElBQUk7WUFDUCxPQUFPLElBQUksQ0FBQztRQUNkLEtBQUssSUFBSTtZQUNQLE9BQU8sSUFBSSxDQUFDO1FBQ2QsS0FBSyxJQUFJO1lBQ1AsT0FBTyxJQUFJLENBQUM7UUFDZCxLQUFLLElBQUk7WUFDUCxPQUFPLElBQUksQ0FBQztRQUNkLEtBQUssSUFBSTtZQUNQLE9BQU8sSUFBSSxDQUFDO1FBQ2QsS0FBSyxJQUFJO1lBQ1AsT0FBTyxJQUFJLENBQUM7UUFDZCxLQUFLLElBQUk7WUFDUCxPQUFPLElBQUksQ0FBQztLQUNmO0lBRUQsTUFBTSxJQUFJLEtBQUssQ0FBQyw4QkFBNEIsSUFBSSxrQkFBYSxJQUFNLENBQUMsQ0FBQztBQUN2RSxDQUFDLENBQUMifQ==